import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  FullStressTypeCSVDownloadResponse,
  ActionType,
  IFullStressTypeDownloadCsvData,
} from "models/stressCheck/fullStressTypeDownloadCsv";
import { httpStatus } from "configs/httpStatus";
import { downloadFullStressCsvRequest } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./fullStressDownloadCsvActions";

function* fullStressCsvDownloadSaga({
  payload,
}: {
  payload: IFullStressTypeDownloadCsvData;
}) {
  try {
    const response: FullStressTypeCSVDownloadResponse = yield call(
      downloadFullStressCsvRequest,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onDownloadFullStressCsvWatcher() {
  yield takeLatest(
    ActionType.FULL_STRESS_TYPE_DOWNLOAD_CSV as any,
    fullStressCsvDownloadSaga
  );
}

export default [fork(onDownloadFullStressCsvWatcher)];
